export async function getInfo(contract, tokenId) {
  try {
    const query = { "nft_info": { "token_id": tokenId } };
    const base64Query = btoa(JSON.stringify(query));

    const lcdUrl = `https://terra-classic-lcd.publicnode.com/cosmwasm/wasm/v1/contract/${contract}/smart/${base64Query}`;
    const lcdRes = await fetch(lcdUrl);
    const lcdData = await lcdRes.json();

    const tokenUriRaw = lcdData?.data?.token_uri;
    const extension = lcdData?.data?.extension;

    if (!tokenUriRaw && !extension) {
      return [null, null];
    }

    // 🛠 Convert ipfs:// to gateway URL if needed
    const tokenUri = tokenUriRaw?.startsWith("ipfs://")
      ? `https://gateway.lighthouse.storage/ipfs/${tokenUriRaw.replace("ipfs://", "")}`
      : tokenUriRaw;

    // 🧪 Attempt to fetch and parse token_uri as JSON metadata
    try {
      const metaRes = await fetch(tokenUri);
      const contentType = metaRes.headers.get("Content-Type") || "";

      if (contentType.includes("application/json")) {
        const metaData = await metaRes.json();

        const image = metaData?.image?.startsWith("ipfs://")
          ? `https://gateway.lighthouse.storage/ipfs/${metaData.image.replace("ipfs://", "")}`
          : metaData?.image || null;

        const name = metaData?.name || extension?.name || null;

        return [name, image];
      } else {
        // Not JSON, likely an image file
        const name = extension?.name || null;
        return [name, tokenUri];
      }
    } catch (jsonErr) {
      // JSON parsing failed, treat token_uri as image
      console.warn("⚠️ token_uri is not JSON. Using as image.", jsonErr);
      const name = extension?.name || null;
      return [name, tokenUri];
    }
  } catch (err) {
    console.error("❌ Error in getInfo:", err.message || err);
    return [null, null];
  }
}
